import * as RadixProgress from '@radix-ui/react-progress';
import styled, { css } from 'styled-components';
import { getCurrentColorStatus } from './helpers';
import { Flex } from '../Flex';
export const Container = styled(Flex) `
	footer {
		white-space: pre-line;
	}
`;
export const Root = styled(RadixProgress.Root) `
	--root-progress-bg: var(${({ backgroundColor }) => backgroundColor || '--surface-primary'});

	background-color: ${({ hasFeedback }) => (hasFeedback ? 'var(--semantic-erro-base)' : 'var(--root-progress-bg)')};
	border-radius: 8px;

	height: ${({ height }) => (height ? `${height}` : '12px')};
	width: 100%;

	overflow: hidden;

	${({ backgroundPadding }) => backgroundPadding &&
    css `
			padding: ${backgroundPadding};
		`}
`;
export const Indicator = styled(RadixProgress.Indicator) `
	background: ${({ status }) => getCurrentColorStatus(status)};

	border-radius: 8px;

	width: ${({ value }) => value}%;
	height: 100%;

	transition: all ${({ transitionTime }) => (transitionTime ? `${transitionTime}ms` : '200ms')} ease-in-out;

	${({ predominantColor }) => predominantColor &&
    css `
			background-color: var(${predominantColor});
		`}
`;
//# sourceMappingURL=styles.js.map